export default __webpack_public_path__ + "static/media/vyrx.79aeb414.png";